<template>
  <div class="w-full">
    <div class="w-full md:px-6 px-2">
      <div class="md:flex md:flex-wrap">
        <div class="py-10 md:w-full w-full md:pr-6">
          <h1 class="text-3xl text-gray-900 font-bold mb-10">Lehrkurse verwalten</h1>
          <div class="w-full flex justify-between content-center mb-6">
            <h2 class="text-gray-900 text-xl">Meine Lehrkurse</h2>
            
            <button
            class="bg-green-500 hover:bg-green-600 text-white font-bold py-1 px-4 rounded-full"
            >
            <router-link to="/new-course"> Neuen Kurs erstellen </router-link>
          </button>
        </div>
        <div >
          <font-awesome-icon class="text-xl" :icon="['fas', 'user-circle']" /> {{ user.firstName }} {{ user.lastName }} 
            <p></p>
          <font-awesome-icon class="text-xl" :icon="['fa-solid', 'fa-at']" /> {{ user.email }}
        </div>
          <div
            class="mb-6 bg-white w-full border-r-4 border-blue-500 px-4 pt-5 pb-8 shadow-md"
            v-for="(course) in usersCourses"
            :key="course.name"
          >
            
              <div class="w-full flex justify-between content-center mb-2">
                <b-tag class="text-gray-600 text-sm">{{ course.skill.name }}</b-tag>
                
                <section>
                  
                  
                  <div>
                  <router-link v-if="course.noLicence || course.isInviteCourse" v-bind:to="'/invite/' + course.id">
                  <b-button
                  class="bg-blue-500 hover:bg-blue-600 text-white font-bold px-3 rounded-full mr-2"
                  >
                    Einladungen
                  </b-button>
                  </router-link>
                  <router-link v-bind:to="'/courses/' + course.id">
                  <b-button
                    class="bg-yellow-500 hover:bg-yellow-600 text-white font-bold px-3 rounded-full mr-2"
                  >
                    Bearbeiten
                  </b-button>
                </router-link>
                      <b-button
                     v-if="superAdmin"
                     type="is-danger"
                      class="text-white font-bold px-3 rounded-full"
                      @click="deleteCourse(course)"
                      >
                      Löschen
                    </b-button> 
                </div>
              </section>
              </div>
              <div class="mb-3 md:flex items-center justify-between">
                <h4 class="text-gray-800 font-medium md:w-2/5 w-full">
                  {{ course.name }}
                </h4>
                <div class="mx-2 mr-2 mb-3 md:flex items-center justify-between">
                <h4 v-if="course.instructor.email != user.email"> 
                  <b-tag rounded type="is-warning" size="is-medium">Anderer Autor</b-tag>  
                  <h4 v-if="course.instructor.email != user.email">{{ course.instructor.email }} </h4>
                </h4>
                  <h4 v-else-if="course.instructor.email == user.email"> 
                  <b-tag rounded type="is-success" size="is-medium">Mein Kurs</b-tag>  
                </h4>
                  </div>
             
                <span>
                <ul
                  class="md:flex items-center justify-between md:pl-6 md:w-3/5"
                >
                <li
                    class="text-gray-600 flex items-center text-xs md:mr-4 my-2"
                  >
                  <font-awesome-icon
                    v-if="!course.isPublic"
                    :icon="lockedIcon"
                    class="mr-2 mb-3"
                    />
                </li>
                <li
                    class="text-gray-600 flex items-center text-xs md:mr-4 my-2"
                  >
                  <font-awesome-icon
                  v-if="course.isProtected"
                  :icon="lockedIcon"
                  color="red"
                  class="mr-2 mb-3"
                  />
                </li>
                  <li
                    class="text-gray-600 flex items-center text-xs md:mr-4 my-2"
                  >
                  <font-awesome-icon
                  v-if="course.noLicence"
                  :icon="lockedIcon"
                  color="blue"
                  class="mr-2 mb-3"
                  />
                  </li>
                  <li
                    class="text-gray-600 flex items-center text-xs md:mr-4 my-2"
                  >
                  <font-awesome-icon
                  v-if="course.isDraft"
                  :icon="lockedIcon"
                  color="orange"
                  class="mr-2 mb-3"
                  />
                  </li>
                  <li
                    class="text-gray-600 flex items-center text-xs md:mr-4 my-2"
                  >
                  <font-awesome-icon
                  v-if="course.isInviteCourse && !course.isInvite"
                  :icon="lockedIcon"
                  color="green"
                  class="mr-2 mb-3"
                  />
                  </li>
                  <li
                    class="text-gray-600 flex items-center text-xs md:mr-4 my-2"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon icon-tabler icon-tabler-clock"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" />
                      <circle cx="12" cy="12" r="9" />
                      <polyline points="12 7 12 12 15 15" />
                    </svg>
                    <span class="mx-2">|</span>
                    <b-field>
                    <b-tag>{{ course.duration }}</b-tag>
                  </b-field>
                  </li>
                  <li
                    class="text-gray-600 flex items-center text-xs md:mr-4 my-2"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon icon-tabler icon-tabler-file-horizontal"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" />
                      <path d="M16 5v4a1 1 0 0 0 1 1h4" />
                      <path
                        d="M3 7v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2 -2v-7l-5 -5h-11a2 2 0 0 0 -2 2z"
                      />
                    </svg>
                    <span class="mx-2">|</span>
                    <b-field>
                    <b-tag>{{ course.sections.length }} Kapitel</b-tag>
                  </b-field>
                  </li>
                  <li class="text-gray-600 flex items-center text-xs">
 <!--                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon icon-tabler icon-tabler-calendar-event"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" />
                      <rect x="4" y="5" width="16" height="16" rx="2" />
                      <line x1="16" y1="3" x2="16" y2="7" />
                      <line x1="8" y1="3" x2="8" y2="7" />
                      <line x1="4" y1="11" x2="20" y2="11" />
                      <rect x="8" y="15" width="2" height="2" />
                    </svg>
                    <span class="mx-2">|</span>
                    <p>17 Aug - 19 Sept</p> -->
                  </li>
                </ul>
              </span>
              </div>
              <div class="md:flex items-center">
                <div class="md:w-2/5 md:mb-0 mb-4">
                  <p class="text-sm text-gray-600">
                    {{ course.description }}
                  </p>
                </div>
                <!-- <div class="mx-2 mr-2 mb-3">
                  <h4 v-if="course.instructor.email == user.email"> 
                  <b-tag rounded type="is-success" size="is-medium">Mein Kurs</b-tag>  
                </h4>
                </div> -->
              </div>
              <div>
                <template>
                <b-taglist>
<!--                     <b-tag v-if="course.polizei" type="is-info">Polizei</b-tag>
                    <b-tag v-if="course.feuerwehr" type="is-danger">Feuerwehr</b-tag> -->
                  </b-taglist>
                </template>
              </div>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState } from "vuex";
import gql from "graphql-tag";

import Buefy from 'buefy';
import { ToastProgrammatic as Toast} from 'buefy';
import 'buefy/dist/buefy.css'

import { library } from "@fortawesome/fontawesome-svg-core";
import { faLock, faUserShield } from "@fortawesome/free-solid-svg-icons";
library.add(faLock, faUserShield);

Vue.use(Buefy);

export default {
  name: "HelloWorld",
  data: function () {
    return {
      user: JSON.parse(localStorage.getItem("user"))
        ? JSON.parse(localStorage.getItem("user"))
        : { role: { name: 0 } },
      lockedIcon: "fas fa-lock",
      lockedIconShield: "fa-solid fa-user-shield",
      API_URL:
      process.env.NODE_ENV == "production"
        ? process.env.VUE_APP_STRAPI_API_URL
        : "localhost:1338",
      superAdmin: false,
      isLoading: true,
      isFullPage: true
    };
  },
  updated(){
    console.log("page updated")
  },
  mounted(){
    if(this.user.user_permissions.some((p) => p.key === "super_admin" )){
      console.log("Dieser User hat Super_admin Kräfte")
      this.superAdmin = true
    }
    this.open()
  },
  methods:{
    open() {
    const loadingComponent = this.$buefy.loading.open({
        container: this.isFullPage ? null : this.$refs.element.$el
    })
    setTimeout(() => loadingComponent.close(), 1.5 * 1000)
  },
  async deleteCourse(courseIndex) {
   // console.log("delete courseID", courseIndex.name)
/*   
      console.log("delete courseID", courseIndex.id)
      console.log("delete course", courseIndex) */
      try{
        this.$buefy.dialog.confirm({
            title: `Kurs löschen`,
            message: `Bist du dir sicher, dass du den Kurs: <b>`+ courseIndex.name +`</b> für immer <b>löschen</b> möchtest? Diese Aktion kann nicht rückgängig gemacht werden.`,
            confirmText: 'Kurs löschen',
            type: 'is-danger',
            hasIcon: true,
            onConfirm: () => {
              this.$store.dispatch("delete", courseIndex)
              location.reload(this.$router.currentRoute)
              this.$buefy.toast.open('Der Kurs wurde erfolgreich gelöscht!')
            }
        })
/*         
        if (confirm('Bist du dir sicher, dass du den Kurs für immer löschen möchtest?')) {
          // delete it!
          this.$store.dispatch("delete", courseIndex);
          location.reload(this.$router.currentRoute);
          Toast.open({
              message: `Der Kurs wurde erfolgreich gelöscht!`,
              duration: 6000,
              position: 'is-top',
              type: 'is-success is-light'
           })
        } else {
          // Do nothing!
          Toast.open({
              message: `Der Kurs wurde nicht gelöscht!`,
              duration: 6000,
              position: 'is-top',
              type: 'is-warning is-light'
           })
        } */
        /* 
        Toast.open({
          message: `Der Kurs wurde erfolgreich gelöscht!`,
          duration: 8000,
          progressBar: true,
          position: 'is-top-center',
          type: 'is-success',
          pauseOnHover: true
        }) */
        //this.$router.push({path: "/newcoursechoice"});
        //this.$router.go(-1);
      }catch(error){
        Toast.open({
            message: `Der Kurs konnte nicht gelöscht werden! Bitte wenden Sie sich an den Administrator!`,
            duration: 8000,
            position: 'is-top',
            type: 'is-danger is-light'
         })
        //console.log("error deleteDourse courseDetails",error)
      }
    },
  },
    apollo: {
    courseCategories: {
      query: gql`
        query {
          courseCategories {
            id
            name
            courses (sort: "name:asc") {
              id
              name
              description
              isProtected
              isPublic
              isInvite
              isInviteCourse
              isDraft
              noLicence
              duration
              skill {
                name
              }
              instructor {
                firstName
                lastName
                email
              }
              sections {
                name
                description
                modules {
                  name
                  description
                }
              }
            }
          }
        }
      `,
    },
        // watchLoading will be called whenever the loading state changes
/*     watchLoading (isLoading, countModifier) {
      // isLoading is a boolean
      // countModifier is either 1 or -1
          isLoading += countModifier
    console.log('Global loading', isLoading, countModifier)
    }, */
  },
  computed: {
    ...mapState({
      courseCategories: "courseCategories",
      usersCourses: "usersCourses",
    }),
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("https://unpkg.com/tailwindcss@^2/dist/tailwind.min.css");
body {
  font-family: "Lato", sans-serif;
  text-align: left;
}
.checkbox:checked {
  border: none;
}
.checkbox:checked + .check-icon {
  display: flex;
}
.color-blue {
  color: #0047ab;
}
</style>
